export const edudata = [
  {
    id: 1,
    date: "Aug 2024 to Present",
    insitute: "JAIN (Deemed-to-be University)",
    address: "Bangalore, India",
    degree: "Ph.D (Pursuing)",
    score: "Pursuing"
  },
  {
    id: 2,
    date: "Aug 2018 to Jan 2021",
    insitute: "GNDEC",
    address: "Ludhiana, Punjab, India",
    degree: "M.Tech (CSE)",
    score: 76
  },
  {
    id: 3,
    date: "Aug 2013 to Aug 2017",
    insitute: "Punjab Technical University",
    address: "Kapurthala, Punjab",
    degree: "B.Tech (CSE)",
    score: 71
  },
  {
    id: 4,
    date: "2011 - 2013",
    insitute: "JKBOSE",
    address: "Anantnag, Jammu and Kashmir",
    degree: "12th",
    score: 75
  }
];
